import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/** The product name: the whole document title on a route with none of its own, the suffix otherwise. */
export const APP_TITLE = 'AnotherTrip Creator';

/**
 * Names every page in the browser tab and for screen readers: `{route title} | AnotherTrip Creator`.
 *
 * The title comes from the route's static `title`, and the deepest route that sets one wins, so a child with
 * none reads its parent's. The signed-out pages carry titles, and signed-in routes are gaining them (Billing, the
 * not-found page); a route with none falls back to the product name alone, as the whole app did before. Mirrors
 * operator-web's `AppTitleStrategy`.
 */
@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this.title.setTitle(pageTitle ? `${pageTitle} | ${APP_TITLE}` : APP_TITLE);
  }
}
